module.exports = __webpack_public_path__ + "img/submit-bg.77dbb14.png";